import { navigate } from '@gatsbyjs/reach-router';
import React from 'react';
import CommandPalette from 'react-cmdk';
import Loading from '~/components/atom/Loading';
import { useGetFlowsV2Query } from '~/graphql/types';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import { pageSelector, type PalettePage } from '../../state';
import { useSetRecoilState } from 'recoil';
import Icon from '~/components/atom/Icon';

const PAGE_ID: PalettePage = 'open-flow';

const FlowsPage: React.FC<{}> = () => {
  const setPage = useSetRecoilState(pageSelector);
  const account = useCurrentAccount();
  const { data, loading } = useGetFlowsV2Query({
    variables: {
      accountId: account.id,
    },
  });

  if (loading) {
    return (
      <CommandPalette.Page id={PAGE_ID}>
        <Loading />
      </CommandPalette.Page>
    );
  }

  return (
    <CommandPalette.Page id={PAGE_ID} onEscape={() => setPage('root')}>
      <CommandPalette.List key={PAGE_ID} heading="Flows openen">
        {data?.getFlowsV2.items.map(({ id, name, ...rest }, index) => (
          <CommandPalette.ListItem
            key={id}
            index={index}
            icon={() => <Icon name="branches" color={{ group: 'secondary' }} />}
            onClick={() => {
              setPage('root');
              void navigate(`/-/automation/flows/builder-v2/update/${id}`);
            }}
            showType={false}
            {...rest}
          >
            {name}
          </CommandPalette.ListItem>
        ))}
      </CommandPalette.List>
    </CommandPalette.Page>
  );
};

export default FlowsPage;
